import { APIStatus } from '@application/enums/api-status';
import { createSlice } from '@reduxjs/toolkit';
import { getStepsFieldsResponsesByRegistrationIdAsync, getAllActiveResponsesByEventIdGroupedByRegistrationAsync, getAllArchivedResponsesByEventIdGroupedByRegistrationAsync, getAllResponsesGridLabelsByEventIdAsync, getAllResponsesLabelsByEventIdAsync, updateResponseGridLabelsAsync, updateResponsesAsync, archiveResponsesAsync, unarchiveResponsesAsync, deleteResponsesAsync, exportResponsesToExcelAsync } from './vdkEventResponsesThunk';
const initialState = {
    status: APIStatus.IDLE
};
export const vdkEventResponseSlice = createSlice({
    name: 'vdkEventResponse',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getStepsFieldsResponsesByRegistrationIdAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
            state.stepsFieldsResponses = undefined;
        })
            .addCase(getStepsFieldsResponsesByRegistrationIdAsync.fulfilled, (state, action) => {
            state.status = APIStatus.SUCCESS;
            state.stepsFieldsResponses = action.payload;
        })
            .addCase(getStepsFieldsResponsesByRegistrationIdAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        })
            .addCase(getAllActiveResponsesByEventIdGroupedByRegistrationAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(getAllActiveResponsesByEventIdGroupedByRegistrationAsync.fulfilled, (state, action) => {
            state.status = APIStatus.SUCCESS;
            state.allResponsesByEventId = action.payload;
        })
            .addCase(getAllActiveResponsesByEventIdGroupedByRegistrationAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        })
            .addCase(getAllArchivedResponsesByEventIdGroupedByRegistrationAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(getAllArchivedResponsesByEventIdGroupedByRegistrationAsync.fulfilled, (state, action) => {
            state.status = APIStatus.SUCCESS;
            state.allArchivedResponsesByEventId = action.payload;
        })
            .addCase(getAllArchivedResponsesByEventIdGroupedByRegistrationAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        })
            .addCase(getAllResponsesGridLabelsByEventIdAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(getAllResponsesGridLabelsByEventIdAsync.fulfilled, (state, action) => {
            state.status = APIStatus.SUCCESS;
            state.allResponsesGridLabelsByEventId = action.payload;
        })
            .addCase(getAllResponsesGridLabelsByEventIdAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        })
            .addCase(getAllResponsesLabelsByEventIdAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(getAllResponsesLabelsByEventIdAsync.fulfilled, (state, action) => {
            state.status = APIStatus.SUCCESS;
            state.allResponsesLabelsByEventId = action.payload;
        })
            .addCase(getAllResponsesLabelsByEventIdAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        })
            .addCase(updateResponseGridLabelsAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(updateResponseGridLabelsAsync.fulfilled, (state, action) => {
            state.status = APIStatus.SUCCESS;
            state.allResponsesLabelsByEventId = action.payload;
        })
            .addCase(updateResponseGridLabelsAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        })
            .addCase(updateResponsesAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(updateResponsesAsync.fulfilled, (state, action) => {
            state.status = APIStatus.SUCCESS;
            state.stepsFieldsResponses = action.payload;
        })
            .addCase(updateResponsesAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        })
            .addCase(archiveResponsesAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(archiveResponsesAsync.fulfilled, (state, action) => {
            state.status = APIStatus.SUCCESS;
            state.archiveResponses = action.payload;
        })
            .addCase(archiveResponsesAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        })
            .addCase(unarchiveResponsesAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(unarchiveResponsesAsync.fulfilled, (state, action) => {
            state.status = APIStatus.SUCCESS;
            state.unarchiveResponses = action.payload;
        })
            .addCase(unarchiveResponsesAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        })
            .addCase(deleteResponsesAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(deleteResponsesAsync.fulfilled, (state, action) => {
            state.status = APIStatus.SUCCESS;
            state.deleteResponses = action.payload;
        })
            .addCase(deleteResponsesAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        })
            .addCase(exportResponsesToExcelAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(exportResponsesToExcelAsync.fulfilled, (state, action) => {
            state.status = APIStatus.SUCCESS;
            state.exportResponsesToExcel = action.payload;
        })
            .addCase(exportResponsesToExcelAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
    }
});
export default vdkEventResponseSlice.reducer;
